var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnbounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unbounce 1",
    clipPath: "url(#clip0_6874_146931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0.5C8.95422 0.5 0 9.45422 0 20.5C0 31.5458 8.95406 40.5 20 40.5C31.0462 40.5 40 31.5458 40 20.5C40 9.45422 31.0462 0.5 20 0.5ZM14.4703 34.5666C14.6749 33.2525 14.8847 31.9392 15.0997 30.6267C10.6948 28.4189 7.90328 23.9741 8.61531 18.8372C9.58687 11.8606 14.9587 8.28297 21.7141 8.89156C22.2264 8.16656 22.7886 7.47063 23.4287 6.79734C24.5683 5.52328 26.2631 5.48328 25.5009 6.99297C23.9644 9.90047 23.3572 12.0956 22.0375 15.6206C20.7223 19.3698 18.6892 24.8727 15.9828 34.5342C15.787 35.4192 14.4003 35.278 14.4703 34.5666ZM31.395 21.7547C30.5166 28.4161 24.2903 32.1964 18.1011 31.5437C18.5503 30.0247 18.7631 29.377 19.2839 28.1527C19.6767 27.4461 21.1473 27.1575 22.2895 26.672C24.6094 25.8383 26.3909 23.7677 26.7275 21.1547C26.9644 19.302 26.4231 17.5269 25.3623 16.1547C24.6206 15.2134 23.9214 14.643 24.1602 13.7594C24.5116 12.5662 24.7811 11.6808 25.4363 10.1816C29.5028 12.3659 32.038 16.9025 31.395 21.7547ZM13.2878 19.4344C13.0581 21.2162 13.5434 22.9172 14.5162 24.2589C15.1647 25.125 15.6613 25.6298 15.9045 26.0273C16.7058 21.6872 17.2842 19.4422 18.055 16.9233C18.4006 15.8711 18.9731 14.3952 19.3873 13.3905C18.8933 13.5558 18.1922 13.7397 17.6197 13.9639C15.3516 14.8142 13.618 16.8638 13.2878 19.4344Z",
    fill: "#278CC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6874_146931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbounce);
export default __webpack_public_path__ + "static/media/unbounce.8a074023c00ccdf3bd23e28f3dee4469.svg";
export { ForwardRef as ReactComponent };